
import { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "../../App.styles"
import Modal from "../Modal"
import RichEditor from "../RichEditor"
import Spinner from "../Spinner"
import { useCreateChunkMutation, useUpdateChunkMutation } from "./NubsUpload.state"

const ModalHtml = ({ onDismiss, show, useQuery, taskId, editId }) => {
    const { t } = useTranslation()
    const [modalValue, setModalValue] = useState({ chunk: '' })
    const { isLoading: isCreating, mutateAsync } = useCreateChunkMutation({ taskId, useQuery })
    const { isLoading: isEditing, mutateAsync: edit } = useUpdateChunkMutation({ taskId, useQuery })
    const [collection] = useQuery()
    const onSave = async e => {
        e.preventDefault()
        const { chunk } = modalValue
        if (editId) {
            await edit({chunk, id: editId})
        } else {
            await mutateAsync(chunk)
        }

        onDismiss()
        setModalValue({ chunk: '' })
    }
    
    const isLoading = useMemo(() => {
        return isCreating || isEditing
    }, [isCreating, isEditing])

    const defaultValue = useMemo(() => {
        const currentNub = (collection?.nubs || []).find(n => parseInt(n.id) === parseInt(editId))
        if (editId && currentNub) {
            return currentNub.chunk || ''
        }
        return ''
    }, [collection?.nubs, editId])

    return show
        ? (
            <Modal onDismiss={onDismiss} show={true} size="lg" className="modal--html">
                <div className="modal-body">
                    <RichEditor
                        disabled={isLoading}
                        name="chunk"
                        // reset query because this uses custom handleOnBlur
                        useQuery={() => [{ chunk: defaultValue }, () => null]}
                        handleOnBlur={chunk => setModalValue({ chunk })}
                        toolbarButtons={(buttons) => {
                            return {
                                ...buttons,
                                moreMisc: {
                                    ...buttons.moreMisc,
                                    // by default the rich editor is set to show in code view;
                                    // setting buttonsVisible to an arbritary large number will make sure
                                    // all misc buttons are shown and user can click on the code view toggle.
                                    buttonsVisible: 99,
                                }
                            }
                        }}
                        events={{
                            'commands.after': function () {
                                try {
                                    if (this.codeView.isActive()) {
                                        // Focus then clear the value of the rich editor textarea
                                        const textarea = this.$box[0].querySelector('.fr-code')
                                        textarea.click()
                                        if (textarea.value === '\n') {
                                            textarea.value = ''
                                        }
                                    }
                                } catch {}
                            }
                        }}
                    />
                </div>
                <div className="modal-footer">
                    <Button disabled={isLoading} className="btn--flat" data-dismiss="modal" onClick={onDismiss} outline>
                        {t('Cancel')}
                    </Button>
                    <Button disabled={isLoading} className="btn--flat" data-dismiss="modal" onClick={onSave} color="primary">
                        {t('Save')} { isLoading ? <Spinner size="0.875rem" /> : null }
                    </Button>
                </div>
            </Modal>
        )
        : null
}

export default ModalHtml